import { TemplateConfig } from '../types';

export const fortuneNearMidFarConfig: TemplateConfig = {
  id: 'fortune-near-mid-far',
  name: '运势近中远',
  description: '分析近期、中期、远期的桃花运势',
  cardCount: 3,
  
  fieldDefaults: {
    title: '我的桃花运势',
    customerQuestion: '**我近期的桃花运的情况分析**',
    cardPlaceholders: [
      '请输入第 1 行第 1 张牌',
      '请输入第 1 行第 2 张牌',
      '请输入第 1 行第 3 张牌'
    ],
    cardInfos: [
      '最近一段时间的运势状况',
      '接下来一段时间的运势状况',
      '再接下来一段时间的运势状况'
    ]
  },
  
  disabledFields: ['cardCount', 'cardInfos'],
  
  generateOptions: {
    normal: true,
    thinking: true
  },
  
  ui: {
    color: '#fa8c16',
    backgroundColor: '#fff7e6',
    icon: '🌟'
  },

  spreadLayout: {
    coordinate: 'normalized',
    cardSize: {
      widthRatio: 0.25,
      heightRatio: 0.65875,
      anchor: 'center'
    },
    positions: [
      { x: 0.2, y: 0.5 },
      { x: 0.5, y: 0.5 },
      { x: 0.8, y: 0.5 }
    ]
  }
};
